<template >
    <div class="handle-charge-dialog">
        <el-dialog
            :visible.sync="visible"
            :title="type === 'money' ? $t('Member.up_money') : $t('Member.yan')"
            left >
            <div v-if=" clientInfo" class="handle-charge-title">
                <p>{{ $t('Common.name') }}：{{ clientInfo.clientName }}</p>
                <p>{{ $t('Common.phone') }}：{{ clientInfo.clientPhone }}</p>
                <template v-if="type === 'day'">
                    <p>{{ $t('Common.store') }}：{{ clientInfo.storeName }}</p>
                    <p>{{ $t('Reception.First.validity') }}：{{ clientInfo.validity }}</p>
                    <p>{{ $t('Member.saler2') }}：{{ clientInfo.contractSalesStaffNickname }}</p>
                    <p>{{ $t('Common.remark') }}：{{ clientInfo.remark }}</p>
                </template>
            </div>
            <el-form
                class="handle-charge-form"
                v-if="clientInfo"
                ref="form"
                :model="form"
                :rules="rules"
                label-suffix=":"
                label-width="160px"
                label-position="right">
                <template v-if="type === 'money'">
                    <el-form-item :label="$t('Common.store')">
                        {{ clientInfo.storeName }}
                    </el-form-item>
                    <el-form-item :label="$t('Reception.First.validity')">
                        {{ clientInfo.validity }}
                    </el-form-item>
                    <el-form-item :label="$t('Member.saler2')">
                        {{ clientInfo.contractSalesStaffNickname }}
                    </el-form-item>
                    <el-form-item :label="$t('Common.remark')">
                        {{ clientInfo.remark }}
                    </el-form-item>
                    <div class="handle-charge-line"></div>
                    <el-form-item
                        :label="$t('Charge.total_existing_deposit')"
                    >{{ clientInfo.amt }}</el-form-item>
                    <el-form-item :label="$t('Sell.Pay.title')" prop="payMethodCode">
                        <el-select style="width: 186px" v-model="form.payMethodCode">
                            <el-option
                                v-for="item in options"
                                :key="item.code"
                                :label="item.name"
                                :value="Number(item.code)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('Sell.Charge.ding')" prop="money">
                        <el-input
                            class="mr-2"
                            style="width: 168px"
                            type="number"
                            :min="1"
                            :placeholder="$t('Fill.charge_amt')"
                            v-model.number="form.money"></el-input>
                            {{ $t('Reception.Fifth.yuan') }}
                    </el-form-item>
                    <el-form-item :label="$t('Charge.total_deposit')">
                        {{ Number(clientInfo.amt) + form.money }}
                    </el-form-item>
                </template>
                <template v-else>
                    <el-form-item :label="$t('Week.extension')" prop="days">
                        <el-input
                            class="mr-2"
                            style="width: 168px;"
                            type="number"
                            :min="1"
                            :placeholder="$t('Fill.extension')"
                            v-model.number="form.days"
                        ></el-input>
                        {{ $t('Week.day2') }}
                    </el-form-item>
                </template>
            </el-form>
            <div style="text-align:center">
                <el-button
                    @click="submit"
                    type="primary"
                >{{ $t('Common.next_step') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    Dialog,
    DatePicker,
    RadioGroup,
    Radio,
    CheckboxGroup,
    CheckboxButton,
    TimePicker,
    Row,
    Autocomplete,
} from 'element-ui';
import PayForm from '@/components/Dialog/Client/PayForm';

export default {
    components: {
        ElDialog: Dialog,
    },
    data() {
        return {
            visible: false,
            type: null,
            contractNum: null,
            clientInfo: null,
            form: {
                payMethodCode: 1,
                money: null,
                days: null,
            },
            rules: {
                payMethodCode: { required: true, message: this.$t('Sell.Pay.methods') },
                money: { required: true, message: this.$t('Sell.Charge.vi_money') },
                days: { required: true, message: this.$t('Sell.Charge.vi_date') },
            },
            options: [
                {
                    code: 1,
                    name: this.$t('Sell.Pay.cash'),
                }, {
                    code: 2,
                    name: this.$t('Sell.Pay.swipe'),
                }, {
                    code: 3,
                    name: this.$t('Sell.Pay.bank'),
                }, {
                    code: 4,
                    name: this.$t('Sell.Pay.alipay'),
                }, {
                    code: 5,
                    name: this.$t('Sell.Pay.wechat'),
                }, {
                    code: 8,
                    name: this.$t('Sell.Pay.other'),
                },
            ],
            url: null,
        };
    },
    watch: {
        'visible'(val) {
            if (!val) this.resetForm();
        },
    },
    methods: {
        resetForm() {
            this.form = {
                payMethodCode: 1,
                money: null,
                days: null,
            };
            setTimeout(() => {
                this.$refs.form.resetFields();
            }, 0);
        },
        open(data, type) {
            this.type = type;
            this.contractNum = data.contractNum;
            this.getDesc();
            this.fetchData();
        },
        getDesc() {
            if (this.type === 'money') this.url = `contract/prepay/${this.contractNum}/amt`;
            else this.url = `contract/prepay/${this.contractNum}/extend`;
        },
        fetchData() {
            API.get(`contract/prepay/${this.contractNum}`)
            .then(res => {
                this.clientInfo = res;
                this.visible = true;
            });
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                this.postData();
            });
        },
        postData() {
            const form = Object.assign({}, this.form);
            if (this.type === 'money') delete form.days;
            else {
                delete form.payMethodCode;
                delete form.money;
            }
            API.post(this.url, form).then(res => {
                const msg = this.type === 'money' ? this.$t('Message.pay_success') : this.$t('Message.success');
                $ele.$message.success(msg);
                this.visible = false;
                this.$emit('fetchData');
            })
            .finally(() => {
                this.loading = false;
            })
            .catch(err => {
                $ele.$message.error(err);
            });
        },
    },
};
</script>

<style lang="scss">
.handle-charge-dialog {
    font-size: 12px;
    .el-dialog {
        background: #fff;
        box-shadow: 1px 1px 50px rgba(0, 0, 0, 0.3);
        width: 540px;
        overflow-y: auto;
        height: auto;
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 25px 0;
    }
    .delete-img {
        top: 0px;
        right: 0px;
        color: gray;
        font-size: 14px;
    }
    .el-dialog__title {
        font-size: 16px;
    }
    .el-dialog__header {
        line-height: 40px;
        background-color: #f2f2f2;
        border-bottom: 1px solid #e6e6e6;
        font-size: 14px;
        color: #333;
        text-align: left;
        padding: 0 45px 0 15px;
    }
}
.handle-charge-title {
    border: 1px solid #e6e6e6;
    padding: 10px;
    background: #f7f7f7;
    font-size: 12px;
    margin-bottom: 15px;
}
.handle-charge-line {
    width: 100%;
    height: 1px;
    background: #e6e6e6;
    margin: 15px 0;
}
.handle-charge-form {
    .el-form-item__content {
        font-size: 12px;
    }
}
</style>
